// ========================================
// components/Footer.js - Reusable Footer Component
// ========================================
// PROJECT: Agyapadie Vault
// LAST MODIFIED: April 16, 2026
// 
// PURPOSE: Consistent footer for all pages (public and authenticated)
// 
// SECTIONS:
// - Logo and tagline
// - Product links
// - Company links  
// - Legal links
// - Social media icons
// - Copyright and design credit
// ========================================

import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-inner">
        
        {/* Logo Section */}
        <div className="footer-logo">
          <img src="/images/symbols/footer-logo.png" alt="Agyapadie Vault" />
          <p>Preserving wealth for generations</p>
        </div>
        
        {/* Links Sections */}
        <div className="footer-links">
          <div className="footer-col">
            <h4>Product</h4>
            <Link to="/features">Features</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/how-it-works">How It Works</Link>
            <Link to="/security">Security</Link>
          </div>
          <div className="footer-col">
            <h4>Company</h4>
            <Link to="/about">About Us</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/faq">FAQ</Link>
          </div>
          <div className="footer-col">
            <h4>Legal</h4>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/compliance">Compliance</Link>
          </div>
        </div>
        
      </div>
      
      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>© 2026 Agyapadie Vault. All rights reserved.</p>
        <p className="design-credit">Powered by <span className="gold">Premium Franchise Ks</span></p>
        <div className="social-links">
          <img src="/images/icons/social-facebook.png" alt="Facebook" />
          <img src="/images/icons/social-twitter.png" alt="Twitter" />
          <img src="/images/icons/social-linkedin.png" alt="LinkedIn" />
          <img src="/images/icons/social-instagram.png" alt="Instagram" />
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .app-footer {
          background: #0A0A0A;
          color: #F5F0E6;
          padding: 60px 40px 30px;
          margin-top: auto;
        }
        
        .footer-inner {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          margin-bottom: 40px;
          flex-wrap: wrap;
          gap: 40px;
        }
        
        .footer-logo img {
          height: 50px;
          margin-bottom: 15px;
        }
        
        .footer-logo p {
          color: #999;
          font-size: 14px;
        }
        
        .footer-links {
          display: flex;
		  flex-wrap: wrap;
          gap: 40pxpx;
        }
        
        .footer-col h4 {
          margin-bottom: 15px;
          font-size: 16px;
          color: #FFD700;
        }
        
        .footer-col a {
          display: block;
          color: #999;
          text-decoration: none;
          font-size: 13px;
          margin-bottom: 10px;
          transition: color 0.3s;
        }
        
        .footer-col a:hover {
          color: #FFD700;
        }
        
        .footer-bottom {
          max-width: 1200px;
          margin: 0 auto;
          padding-top: 20px;
          border-top: 1px solid #222;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 20px;
          font-size: 12px;
          color: #666;
        }
        
        .design-credit {
          color: #666;
        }
        
        .design-credit .gold {
          color: #FFD700;
        }
        
        .social-links {
          display: flex;
          gap: 20px;
        }
        
        .social-links img {
          height: 24px;
          cursor: pointer;
          transition: opacity 0.3s;
        }
        
        .social-links img:hover {
          opacity: 0.7;
        }
        
        @media (max-width: 768px) {
          .app-footer {
            padding: 40px 20px 20px;
          }
          
          .footer-inner {
            flex-direction: column;
            text-align: center;
            gap: 30px;
          }
          
          .footer-links {
		   display: grid;
           grid-template-columns: repeat(3, 1fr);
           gap: 20px;
           text-align: left;
           justify-content: center;
          }
          
		  .footer-col {
            min-width: auto;
		  }
		  
          .footer-bottom {
            flex-direction: column;
            text-align: center;
            gap: 15px;
          }
        }
      `}} />
    </footer>
  );
};

export default Footer;